<template>
	<div class="svg-map-item" :id="mapEleId"></div>
</template>

<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable'
	// 组件
	import {svgDrawMap} from '@/static_dazzle/plugins/svg/svg_draw_map'

	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2021/7/24
		 */
		name: 'SubRaphaelMap',
		props: {
			/**
			 * @Des 地图容器id
			 * @Auth
			 * @Date 2021/7/24
			 */
			mapEleId: {
				type: String,
				default: function (){
					return 'svg_map'
				}
			},
            /**
             * @Des 地图信息
             * @Auth
             * @Date 2021/7/26
             */
            mapOption: {
                type: Object,
                default: function (){
                    return null
                }
            },
        },
		data() {
			return {
				// pagePath
				pagePath: (GlobalVariable.PAGE_PATH + '/static'),
				
				/**
				 * @Des 绘制svg地图
				 * @Auth
				 * @Date 2021/7/24
				 */
				mapItem: new svgDrawMap(this.mapEleId),
				
				// 人员icon 默认
				peopleImgs_default: {},
				// 人员图元
				posiIconsObj: {},

			}
		},
		mounted() {
			// 加载完毕 执行
			
			//this.mapItem = new svgDrawMap(this.mapEleId),
			
			// 人员icon 默认
			this.peopleImgs_default = this.mapItem.getDefaultPeopleImgs();
		},
		created() {
			// 加载完毕

		},
		/**
         * @Des 监听
         * @Auth
         * @Date 2021/7/27
         */
        watch: {
            /**
             * @Des 地图信息 监听
             * @Auth
             * @Date 2021/6/4
             */
            mapOption: {
                handler(newVal, oldVal){
                	return false;
                    // 延时 执行
                    this.$nextTick(() => {
                    	if (!this.$checkEmpty(this.mapOption)) {
							// 初始化地图
							this.initMap(this.mapOption);
						}
                    });
                },
                immediate: true,
                deep:true,
            }
        },
		destroyed: function() {
			// 组件销毁

			// 销毁 svg地图
			this.destroySvg();
		},
		methods: {
			// 方法

			/**
             * @Des 初始化 地图
             * @Auth
             * @Date 2021/7/26
             */
            initMap(mapOption, offset, limitFlag=false) {
            	// 空值 中止
            	if (this.$checkEmpty(mapOption)) return false;
            	// 设置地图参数
            	this.setMapParams(mapOption);
            	// 设置地图 自由缩放
            	this.setLimitState(limitFlag);
            	// 初始化 svg 地图
            	this.initSvg(offset);
            },
			/**
             * @Des 设置地图参数
             * @Auth
             * @Date 2021/7/26
             */
            setMapParams(mapOption) {
            	// 设置地图参数
				this.mapItem.setMapParams(mapOption);
            },
			/**
             * @Des 设置地图参数 mkey
             * @Auth
             * @Date 2022/6/8
             */
            setMapParam(option) {
            	// 设置地图参数
				this.mapItem.setMapParam(option);
            },
            /**
             * @Des 设置地图 自由缩放
             * @Auth
             * @Date 2021/7/27
             */
            setLimitState(flag) {
            	// 设置地图参数
				this.mapItem.setLimitState(flag);
            },
            /**
             * @Des 初始化 svg 地图
             * @Auth
             * @Date 2021/7/26
             */
            initSvg(offset) {
            	// 偏移量 px
            	let offsetArray = this.$checkEmpty(offset) ? [undefined,undefined] : offset;
            	// 初始化 svg 地图
				this.mapItem.initSvg(offsetArray[0], offsetArray[1]);
            },
            /**
             * @Des 销毁 svg 地图
             * @Auth
             * @Date 2021/7/27
             */
            destroySvg() {
            	// 销毁 svg 地图
				this.mapItem.destroySvg();
            },
            //================================================================ 圆点 start ================================================================\\
            /**
             * @Des 设置 可否双击 取点
             * @Auth
             * @Date 2021/7/27
             */
            allowDrawDisc(flag, callBack) {
            	// 绘制 圆点 双击取点
            	this.mapItem.allowDrawDisc(flag, callBack);
            },
            /**
             * @Des 绘制 圆点 双击取点
             * @Auth
             * @Date 2021/7/27
             */
            initDrawDisc(pixelXY, discD, pointXY) {
            	// 'x,y', discD 半径
            	// 绘制 圆点 双击取点
            	this.mapItem.initDrawDisc(pixelXY, discD, pointXY);
            },
            /**
             * @Des 清除点击点 实心圆
             * @Auth
             * @Date 2021/7/27
             */
            clearDiscImg(type) {
            	// "destroy"
            	// 清除 点击点 实心圆
            	this.mapItem.clearDiscImg(type);
            },
            /**
             * @Des 绘制 圆点
             * @Auth
             * @Date 2021/7/26
             */
            loadDotPosition(dotObj) {
            	// dotObj.id, _dotObj.point, dotObj.dotOpt, dotObj.textFlag
            	// 绘制 圆点
            	this.mapItem.loadDotPosition(dotObj);
            },
            /**
             * @Des 清除 圆点 单个
             * @Auth
             * @Date 2021/7/26
             */
            clearDot(id, type) {
            	// "destroy"
            	// 清除 圆点
            	this.mapItem.clearDot(id, type);
            },
            /**
             * @Des 清除 圆点 所有
             * @Auth
             * @Date 2021/7/26
             */
            clearAllDots(type) {
            	// "destroy"
            	// 清除 圆点
            	this.mapItem.clearAllDots(type);
            },
            //================================================================ 圆点 end ================================================================\\

            //================================================================ 区域 围栏 start ================================================================\\
            /**
             * @Des 绘制 区域
             * @Auth
             * @Date 2021/7/26
             */
            drawArea(flag, callBack, lineObj) {
            	// 设置 允许画 区域
				this.allowDrawPoints(flag, callBack, lineObj);

				// 双击 选点  falg | canDraw 可双击取点 不闭合 点可移动
				this.drawFence(!flag, flag);
            },
            /**
             * @Des 绘制区域
             * @Auth
             * @Date 2021/7/26
             */
            allowDrawPoints(flag, callBack, lineObj) {
            	// 是否允许 绘制 区域
				this.mapItem.allowDrawPoints(flag, callBack, lineObj);
            },
            /**
             * @Des 设置 区域 点集合
             * @Auth
             * @Date 2021/7/26
             */
            setPointGroupData(pointGroupData, lineObj) {
            	// 设置 区域 点集合
            	this.mapItem.setPointGroupData(pointGroupData, lineObj);
            },
            /**
             * @Des 设置是否可闭合
             * @Auth
             * @Date 2021/7/26
             */
            setCanClosePoints(flag) {
            	// 设置是否可闭合
				this.mapItem.setCanClosePoints(flag);
            },
            /**
             * @Des 绘制 区域
             * @Auth
             * @Date 2021/7/26
             */
            drawFence(isClose, isDraggable, option, notClear) {
				//画电子围栏  依托于 pointGroup
            	this.mapItem.drawFence(isClose, isDraggable, option, notClear);
            },
            /**
             * @Des 获取 点集合
             * @Auth
             * @Date 2021/7/26
             */
            getDrowPoints() {
            	// 获取 点集合
				return this.mapItem.getDrowPoints();
            },
            /**
             * @Des 清除 区域
             * @Auth
             * @Date 2021/7/26
             */
            clearDrawArea() {
				// 设置 点集合
                this.setPointGroupData([]);
				// 绘制 区域
                this.drawArea(false, (pointXY, points) => {
                	//console.log({pointXY, points});
                });
            },

            /**
			 * 绘制 区域
			 * 必要字段：railObj
			 * @param railObj Rail数据json {}
			 * @returns
			 */
			loadRail(railObj) {
				// railObj.id, railObj.points, lineObj
				// 绘制 区域
            	this.mapItem.loadRail(railObj);
			},
            /**
			 * 清除 区域 单个
			 * 字段：type
			 * @param "destroy" 销毁缓存
			 * @returns
			 */
			clearRail(railId, type) {
				// 清除 区域
            	this.mapItem.clearRail(railId, type);
			},
			/**
			 * 清除 区域 所有
			 * 字段：type
			 * @param "destroy" 销毁缓存
			 * @returns
			 */
			clearAllRails(type) {
				// 清除 区域 所有
            	this.mapItem.clearAllRails(type);
			},
            //================================================================ 区域 围栏 end ================================================================\\

            //================================================================ 人员 start ================================================================\\
            /**
             * @Des 绘制 人员
             * @Auth
             * @Date 2021/7/26
             */
			loadUwbPeoplePosition(posi) {
				// 绘制 人员信息
            	this.mapItem.loadUwbPeoplePosition(posi);
			},
            /**
             * @Des 清除 人员 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearPeoplePosition(id) {
				// "destroy"
				// 清除 人员
            	this.mapItem.clearPeoplePosition(id);
			},
			/**
             * @Des 清除 人员 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllPeoples(type) {
				// "destroy"
				// 清除 人员信息 所有
            	this.mapItem.clearAllPeoples(type);
			},
			/**
             * @Des 定位数量
             * @Auth
             * @Date 2021/7/26
             */
			initPeoleNum(posiNum, alarmNum) {
				// "destroy"
				// 定位数量
            	this.mapItem.initPeoleNum(posiNum, alarmNum);
			},
			/**
             * @Des 图元
             * @Auth
             * @Date 2021/7/26
             */
			getPeopleImg(userType, alarmType, alarmState) {
				// "destroy"
				// 图元
            	return this.mapItem.getPeopleImg(userType, alarmType, alarmState);
			},
            //================================================================ 人员 end ================================================================\\

            //================================================================ 人员信息 start ================================================================\\
            /**
             * @Des 绘制 人员信息 全部
             * @Auth
             * @Date 2021/7/26
             */
			loadAllPeoTxts() {
				// 绘制 人员信息
            	this.mapItem.loadAllPeoTxts();
			},
            /**
             * @Des 清除 人员信息 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearTxtImg(id, type) {
				// "destroy"
				// 清除 人员信息
            	this.mapItem.clearTxtImg(id, type);
			},
			/**
             * @Des 清除 人员信息 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllTxts(type) {
				// "destroy"
				// 清除 人员信息 所有
            	this.mapItem.clearAllTxts(type);
			},
			/**
             * @Des 清除黑名单
             * @Auth
             * @Date 2021/7/26
             */
			clearBlackTxtMap() {
				// "destroy"
				// 清除黑名单
            	this.mapItem.clearBlackTxtMap();
			},
            //================================================================ 人员信息 end ================================================================\\

            //================================================================ 追踪图标 start ================================================================\\
            /**
             * @Des 绘制 追踪图标
             * @Auth
             * @Date 2021/7/26
             */
			trackPeople(id) {
				// 绘制 追踪图标
            	this.mapItem.trackPeople(id);
			},
            /**
             * @Des 清除 追踪图标 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearTrack(id, type) {
				// "destroy"
				// 清除 追踪图标
            	this.mapItem.clearTrack(id, type);
			},
			/**
             * @Des 清除 追踪图标 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllTracks(type) {
				// "destroy"
				// 清除 追踪图标 所有
            	this.mapItem.clearAllTracks(type);
			},
            //================================================================ 追踪图标 end ================================================================\\

            //================================================================ 虚线 start ================================================================\\
            /**
             * @Des 绘制 虚线
             * @Auth
             * @Date 2021/7/29
             */
			loadDottedLine(dottedObj) {
				// dottedObj.id, dottedObj.points, dottedObj.dottedOpt, dottedObj.textFlag
				// 绘制 虚线
            	this.mapItem.loadDottedLine(dottedObj);
			},
			/**
             * @Des 清除 虚线
             * @Auth
             * @Date 2021/7/29
             */
            clearDottedLine(id, type) {
            	// "destroy"
            	// 清除 虚线
            	this.mapItem.clearDottedLine(id, type);
            },
            /**
             * @Des 清除 虚线 所有
             * @Auth
             * @Date 2021/7/29
             */
            clearAllDottedLine(type) {
            	// "destroy"
            	// 清除 虚线 所有
            	this.mapItem.clearAllDottedLine(type);
            },
            //================================================================ 虚线 end ================================================================\\

            //================================================================ 矩形区域 start ================================================================\\
            /**
             * @Des 允许 滑动获取区域
             * @Auth
             * @Date 2021/7/28
             */
			setFingerArea(callback) {
				// 绘制 滑动获取区域
            	this.mapItem.setFingerArea(callback);
			},
            /**
             * @Des 禁止滑动获取区域
             * @Auth
             * @Date 2021/7/28
             */
			stopFingerArea(callBack, keepFlag=false) {
				// "destroy"
				// 清除 禁止滑动获取区域
            	this.mapItem.stopFingerArea(callBack, keepFlag);
			},

			/**
             * @Des 绘制 矩形区域
             * @Auth
             * @Date 2021/7/28
             */
			loadFingerRail(railObj) {
				// "destroy"
				// 绘制 矩形区域
            	this.mapItem.loadFingerRail(railObj);
			},
			/**
             * @Des 清除 矩形区域
             * @Auth
             * @Date 2021/7/28
             */
            clearFingerRail(id, type) {
            	// "destroy"
            	// 清除 矩形区域
            	this.mapItem.clearFingerRail(id, type);
            },
            /**
             * @Des 清除 矩形区域 所有
             * @Auth
             * @Date 2021/7/28
             */
            clearFingerAllRails(type) {
            	// "destroy"
            	// 清除 矩形区域 所有
            	this.mapItem.clearAllIntimeSegs(type);
            },
            //================================================================ 矩形区域 end ================================================================\\

            //================================================================ 实时轨迹 start ================================================================\\
            /**
             * @Des 设置 实时轨迹 开关
             * @Auth
             * @Date 2021/7/27
             */
            setIntimeLineFlag(flag) {
            	// 设置 实时轨迹 开关
            	this.mapItem.setIntimeLineFlag(flag);
            },
            /**
             * @Des 绘制 线段 实时轨迹 list
             * @Auth
             * @Date 2021/7/27
             */
			loadIntimeSegments(posiList) {
				// 绘制 线段 实时轨迹 list
            	this.mapItem.loadIntimeSegments(posiList);
			},
            /**
             * @Des 绘制 线段 实时轨迹
             * @Auth
             * @Date 2021/7/27
             */
            loadIntimeSegment(pointObj) {
            	// pointObj.id, pointObj.pixelX, pointObj.pixelY
            	// 绘制 线段 实时轨迹
            	this.mapItem.loadIntimeSegment(pointObj);
            },
            /**
             * @Des 清除 实时轨迹
             * @Auth
             * @Date 2021/7/27
             */
            clearIntimeSeg(id, type) {
            	// "destroy"
            	// 清除 实时轨迹
            	this.mapItem.clearIntimeSeg(id, type);
            },
            /**
             * @Des 清除 实时轨迹 所有
             * @Auth
             * @Date 2021/7/27
             */
            clearAllIntimeSegs(type) {
            	// "destroy"
            	// 清除 实时轨迹 所有
            	this.mapItem.clearAllIntimeSegs(type);
            },
            //================================================================ 实时轨迹 end ================================================================\\

            //================================================================ 基站 start ================================================================\\
            /**
             * @Des 设置 基站参数
             * @Auth
             * @Date 2021/7/26
             */
            setBsOpt(option) {
                // option.clickBsImg
                // 绘制 摄像头
                this.mapItem.setBsOpt(option);
            },
            /**
             * @Des 绘制 基站
             * @Auth
             * @Date 2021/7/26
             */
			loadStationPosition(stationObj) {
				// stationObj.id, stationObj.pointXPx, stationObj.pointYPx
				// 绘制 基站
            	this.mapItem.loadStationPosition(stationObj);
			},
            /**
             * @Des 清除 基站 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearStation(id, type) {
				// "destroy"
				// 清除 基站
            	this.mapItem.clearStation(id, type);
			},
			/**
             * @Des 清除 基站 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllStations(type) {
				// "destroy"
				// 清除 基站 所有
            	this.mapItem.clearAllStations(type);
			},
            //================================================================ 基站 end ================================================================\\

            //================================================================ 摄像头 start ================================================================\\
            /**
             * @Des 设置 摄像头参数
             * @Auth
             * @Date 2021/7/26
             */
            setCameraOpt(option) {
                // option.clickCameraImg
                // 绘制 摄像头
                this.mapItem.setCameraOpt(option);
            },
            /**
             * @Des 绘制 摄像头
             * @Auth
             * @Date 2021/7/26
             */
			loadCameraPosition(cameraObj) {
				// cameraObj.id, cameraObj.pointXPx, cameraObj.pointYPx
				// 绘制 摄像头
            	this.mapItem.loadCameraPosition(cameraObj);
			},
            /**
             * @Des 清除 摄像头 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearCamera(id, type) {
				// "destroy"
				// 清除 摄像头
            	this.mapItem.clearCamera(id, type);
			},
			/**
             * @Des 清除 摄像头 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllCameras(type) {
				// "destroy"
				// 清除 摄像头 所有
            	this.mapItem.clearAllCameras(type);
			},
            //================================================================ 摄像头 end ================================================================\\

            //================================================================ 旗帜 start ================================================================\\
            /**
             * @Des 绘制 旗帜
             * @Auth
             * @Date 2021/7/26
             */
			loadFlagimgPosition(flagimgObj) {
				// flagimgObj.id, flagimgObj.pixelX, flagimgObj.pixelY, flagimgObj.textFlag
				// flagimgObj.textOpt flagText, fill, width, fontSize
				// 绘制 旗帜
            	this.mapItem.loadFlagimgPosition(flagimgObj);
			},
            /**
             * @Des 清除 旗帜 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearFlagimg(id, type) {
				// "destroy"
				// 清除 旗帜
            	this.mapItem.clearFlagimg(id, type);
			},
			/**
             * @Des 清除 旗帜 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllFlagimgs(type) {
				// "destroy"
				// 清除 旗帜 所有
            	this.mapItem.clearAllFlagimgs(type);
			},
            //================================================================ 旗帜 end ================================================================\\
			
			//================================================================ 工具柜 start ================================================================\\
            /**
             * @Des 设置 工具柜参数
             * @Auth
             * @Date 2021/11/30
             */
            setTkOpt(option) {
                // option.clickTkImg
                // 绘制 工具柜
                this.mapItem.setTkOpt(option);
            },
            /**
             * @Des 绘制 工具柜
             * @Auth
             * @Date 2021/11/30
             */
			loadTkPosition(toolkitObj) {
				// toolkitObj.id, toolkitObj.pointXPx, toolkitObj.pointYPx
				// 绘制 工具柜
            	this.mapItem.loadTkPosition(toolkitObj);
			},
            /**
             * @Des 清除 工具柜 单个
             * @Auth
             * @Date 2021/11/30
             */
			clearTk(id, type) {
				// "destroy"
				// 清除 工具柜
            	this.mapItem.clearTk(id, type);
			},
			/**
             * @Des 清除 工具柜 所有
             * @Auth
             * @Date 2021/11/30
             */
			clearAllTks(type) {
				// "destroy"
				// 清除 工具柜 所有
            	this.mapItem.clearAllTks(type);
			},
            //================================================================ 工具柜 end ================================================================\\
			
            //================================================================ 刻度尺 start ================================================================\\
            /**
             * @Des 数据 刻度尺
             * @Auth
             * @Date 2021/7/26
             */
			setRuleLineData(_ruleLineObj) {
				// ruleLineObj.id, ruleLineObj.startMileage, ruleLineObj.finishMileage, fruleLineObj.workMileage, ruleLineObj.endMileage
				// 绘制 刻度尺
            	this.mapItem.setRuleLineData(_ruleLineObj);
			},
            /**
             * @Des 绘制 刻度尺
             * @Auth
             * @Date 2021/7/26
             */
			loadRuleLine(ruleLineObj) {
				// ruleLineObj.id, ruleLineObj.startMileage, ruleLineObj.finishMileage, fruleLineObj.workMileage, ruleLineObj.endMileage
				// 绘制 刻度尺
            	this.mapItem.loadRuleLine(ruleLineObj);
			},
            /**
             * @Des 清除 刻度尺 单个
             * @Auth
             * @Date 2021/7/26
             */
			clearRuleLine(id, type) {
				// "destroy"
				// 清除 刻度尺
            	this.mapItem.clearRuleLine(id, type);
			},
			/**
             * @Des 清除 刻度尺 所有
             * @Auth
             * @Date 2021/7/26
             */
			clearAllRuleLines(type) {
				// "destroy"
				// 清除 刻度尺 所有
            	this.mapItem.clearAllRuleLines(type);
			},
			//================================================================ 刻度尺 end ================================================================\\
			//================================================================ 比例 start ================================================================\\
			/**
             * @Des 允许 比例图元
             * @Auth
             * @Date 2022/6/8
             */
			allowShowScaleLine(flag, option) {
				// 允许 比例图元
            	this.mapItem.allowShowScaleLine(flag, option);
			},
			/**
             * @Des 绘制图元 比例
             * @Auth
             * @Date 2022/6/8
             */
			loadScaleLine(scaleLineObj={id:'SCALELINE'}) {
				// 绘制图元 比例
            	this.mapItem.loadScaleLine(scaleLineObj);
			},
			/**
             * @Des 清除图元 比例
             * @Auth
             * @Date 2022/6/8
             */
			clearScaleLine(id, type) {
				// "destroy"
				// 清除图元 比例
            	this.mapItem.clearScaleLine(id, type);
			},
			/**
             * @Des 清除 比例 所有
             * @Auth
             * @Date 2022/6/8
             */
			clearAllScaleLines(type) {
				// "destroy"
				// 清除 比例 所有
            	this.mapItem.clearAllScaleLines(type);
			},
			//================================================================ 比例 end ================================================================\\
			
            //================================================================ 轨迹 end ================================================================\\
			/**
			 * @Des 轨迹方法
			 * @Auth
			 * @Date 2021/9/10
			 */
			setTrackFns(fnOpts) {
				this.mapItem.setTrackFns(fnOpts);
			},
			/**
			 * @Des 随即获取颜色
			 * @Auth
			 * @Date 2021/9/10
			 */
			getRandomColor() {
				return this.mapItem.getRandomColor();
			},
			/**
			 * @Des 设置播放flag
			 * @Auth
			 * @Date 2021/9/10
			 */
			setPlayFlag(flag) {
				return this.mapItem.setPlayFlag(flag);
			},
			/**
			 * @Des 创建静态人员
			 * @Auth
			 * @Date 2021/9/10
			 */
			creatStaticPeople(id, info) {
				this.mapItem.creatStaticPeople(id, info);
			},
			/**
			 * @Des 创建移动图元
			 * @Auth
			 * @Date 2021/9/10
			 */
			creatMovePel(id, info, speedV) {
				this.mapItem.creatMovePel(id, info, speedV);
			},
			/**
			 * @Des 绘制静态轨迹线
			 * @Auth
			 * @Date 2021/9/10
			 */
			drawStaticTrackLine(id, points, color, selMapId) {
				this.mapItem.drawStaticTrackLine(id, points, color, selMapId);
			},
			/**
			 * @Des 清除所有
			 * @Auth
			 * @Date 2021/9/10
			 */
			clearTrackAll() {
				this.mapItem.clearTrackAll();
			},
			/**
			 * @Des 获取人员图片
			 * @Auth
			 * @Date 2021/9/10
			 */
			getPeopleImage(userType, alarm) {
				var people_img = '';
				var alarmState = (alarm == 0 ? 0 : 1);
				// 加载从后台获取的图元
				if(!this.$checkEmpty(this.posiIconsObj[userType]) && !this.$checkEmpty(this.posiIconsObj[userType][alarmState])) {
					var _icon = this.posiIconsObj[userType][alarmState];
					if(alarm == 0) {
						// 定位
						people_img = _icon;
					} else {
						// 报警
						people_img = !this.$checkEmpty(_icon[alarm]) ? _icon[alarm] : _icon['default'];
					}
				}
				if(people_img != ''){
					return people_img;
				}
				// 加载 默认 区分图元
				if(!this.$checkEmpty(this.peopleImgs_default[userType]) && !this.$checkEmpty(this.peopleImgs_default[userType][alarmState])) {
					var _img = this.peopleImgs_default[userType][alarmState];
					if(alarm == 0) {
						// 定位
						people_img = _img;
					} else {
						// 报警
						people_img = !this.$checkEmpty(_img[alarm]) ? _img[alarm] : _img['default'];
					}
				}
				if(people_img != ''){
					return people_img;
				}
				// people_img 未找到相应图片时，设置默认图片
				if(alarm != 0){
					people_img = this.pagePath + "/images/map/mapIcons-1/posi-xmarker-blue.gif";
					// '/images/map/people_alarm.png'
				}else{
					people_img = this.pagePath + "/images/map/mapIcons-1/posi-xmarker-blue.png";
					// '/images/map/people_posi.png'
				}
				return people_img;
			},
            //================================================================ 轨迹 end ================================================================\\
            
		},

	}
</script>

<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/SubRaphaelMap.vue